module.exports = __webpack_public_path__ + "static/media/photo_032.de5a0fa7.JPG";